export default "__VITE_ASSET__1ed0827a__"